var map = {
	"./bpr.png": "AKhq",
	"./doding.png": "bj92",
	"./iiw.png": "4okQ",
	"./sisda.png": "JkyL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xyrJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/work ^\.\/.*$
// module id = xyrJ
// module chunks = 0